import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 16 16"
    className="mb-2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00008 1.99194L10.0003 6.4927L14.0014 6.99282L11.0004 9.49322L12.0005 13.994L8.00008 11.4934L3.99937 13.994L4.99955 9.49322L1.99902 6.99282L5.99973 6.4927L8.00008 1.99194Z"
      fill="#F39C12"
    />
    <path d="M8 1.99799V8.49908L10.0003 6.49874L8 1.99799Z" fill="#F1C40F" />
    <path
      d="M8 8.49908L14.001 6.99883L11.0005 9.49924L8 8.49908Z"
      fill="#F1C40F"
    />
    <path d="M8 8.49908L12.0007 14L8 11.4996V8.49908Z" fill="#F1C40F" />
    <path
      d="M8.00018 8.49908L3.99951 14L4.99968 9.49925L8.00018 8.49908Z"
      fill="#F1C40F"
    />
    <path
      d="M8.00003 8.49907L1.99902 6.99882L5.99969 6.49873L8.00003 8.49907Z"
      fill="#F1C40F"
    />
  </svg>
);

const IconAdvertise = (props) => <Icon component={icon} {...props} />;

export default IconAdvertise;
